import Vue from "vue";

Vue.directive('select', {
// When the bound element is inserted into the DOM...
    inserted: function (el) {
        // Focus the element
        el.select()
    }
});